const appVersion = '2.9.87' // 4to nro para estilos, 5to para test DOTS-test-v2.5.9.0.1-android-apk - formato valido de version para release/dev X.X.XX
const versionCode = 980 // incrementar siempre que se suba appVersion

module.exports.isIos =
    process.env.EAS_BUILD_PLATFORM === 'ios' || process.env.PLATFORM === 'ios'

module.exports.android = {
    version: appVersion,
    versionCode: versionCode,
}
module.exports.ios = {
    version: versionCode.toString(),
    buildNumber: appVersion,
}
module.exports.web = {
    version: appVersion,
    versionCode: versionCode,
}
// const isIOS = process.env.EAS_BUILD_PLATFORM === 'ios'
// const isAndroid = process.env.EAS_BUILD_PLATFORM === 'android'
//
//
//
